angular
    .module('app')
    .component('addon', {
        templateUrl: 'app/components/addons/addon/Addon.html',
        controller: Addon,
        bindings: {
            addon: '<',
            obligatory: '<',
            onSave: '&'
        }
    });

function Addon($translate, ENV, Params, Currency, $uibModal) {
    var $this = this;
    $this.$translate = $translate;
    $this.ENV = ENV;
    $this.Params = Params;
    $this.Currency = Currency;
    $this.$uibModal = $uibModal;
}

Addon.prototype = {
    $onInit: function () {
        this.addon.count = this.addon.obligatory ? 1 : 0;
        this.occupancy = this.Params.getOccupancy();
        this.checkIn = this.Params.getCheckIn();
        this.checkOut = this.Params.getCheckOut();
        this.lengthOfStay = moment(this.checkOut).diff(this.checkIn, "days");
    },

    openPresentation: function () {
        var $this = this;
        $this.$uibModal.open({
            component: 'modalPresentation',
            size: 'lg',
            resolve: {
                title: function () {
                    return $this.getAddonName();
                },
                images: function () {
                    return $this.getImages();
                },
                description: function () {
                    return $this.getAddonDescription();
                }
            }
        }).result.then(function () { }, function () { });
    },

    getImages: function () {
        return this.addon.images;
    },

    getThumbnail: function () {
        var images = this.addon.images;
        if (images.length > 0) {
            return this.ENV.images + images[0].src;
        }
        return '/be/assets/img/dummy.png';
    },

    getThumbnailMini: function () {
        var images = this.addon.images;

        if (images.length > 0) {
            const splitStr = images[0].src.split(".");
            return this.ENV.images + splitStr[0] + '-small.' + splitStr[1];
        }
        return '/be/assets/img/dummy.png';
    },

    getAddonName: function () {
        return this.addon.name
    },

    getAddonDescription: function () {
        return this.addon.description
    },

    getAddonUnitMeasure: function () {
        if (this.addon.unitMeasure === 1) {
            return this.$translate.instant('addons.PEOPLE');
        }
        //defaults to units / sztuki
        return this.$translate.instant('addons.UNITS');
    },

    getAddonPricePerUnit: function () {
        var price = this.addon.pricePerUnit;
        return this.Currency.getFormattedPrice(price);
    },

    getAddonPrice: function () {
        var price = this.addon.pricePerUnit;
        var priceMode = this.addon.priceMode;

        if (price <= 0) {
            return this.$translate.instant('addons.INCLUDED');
        }

        // if(priceMode === 1){
        //     var fullPrice = price * this.addon.count;
        //     return this.Currency.getFormattedPrice(fullPrice);
        // }else if(priceMode === 2){
        //     var fullPrice = price * this.addon.count;
        //     return this.Currency.getFormattedPrice(fullPrice);
        // }else if(priceMode === 3){
        //     var fullPrice = price * this.lengthOfStay;
        //     return this.Currency.getFormattedPrice(fullPrice);
        // }else if(priceMode === 4){
        //     var fullPrice = price * this.lengthOfStay * this.addon.count;
        //     return this.Currency.getFormattedPrice(fullPrice);
        // }

        return this.Currency.getFormattedPrice(price);
    },

    addAddon: function () {
        this.addon.added = true;
        this.addon.count = 1;
        this.onSave(this.addon);
    },

    addAddonWithQuantity: function (count) {
        this.addon.count = count;
        this.onSave(this.addon);
    },

    removeAddon: function () {
        this.addon.added = false;
        this.addon.count = 0;
        this.onSave(this.addon);
    }
}